import { render, staticRenderFns } from "./userbx.vue?vue&type=template&id=c65d7706"
import script from "./userbx.vue?vue&type=script&lang=js"
export * from "./userbx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports